import GLightbox from 'glightbox';
import Swiper from 'swiper';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import { $Elements, BrowserEvents, Classes, TransitionDurations } from './constants';
import { getCookiesAllowed, initGTM, isDisclaimerAccepted, replaceHoverByActive, setCookiesAllowed, setDisclaimerAccepted, wait } from './helpers';

//=================================
//	!---------- GLOBAL ----------
//=================================

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- jQuery Related ----------

;(function($) {

	replaceHoverByActive();

	$Elements.document.on(BrowserEvents.page.enter, async() => {

		// ---------- Links ----------

		$('a[href="#"], .void-link').click((e) => e.preventDefault());

		$('[data-scroll-to]').click(function(e) {
			e.preventDefault();

			const self = $(this);
			const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

			if(target.length) {

				$('html, body').stop().animate({
					scrollTop: target.offset().top - $Elements.HeaderWrapper.height()
				}, 1000);
			}
		});

		$('.select-dropdown .dropdown-menu .btn').click(function() {
			$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
		});

		$('[target="lightbox"]').each(function(index) {

			this.classList.add('lightbox-' + index);

			GLightbox({
				selector: 'lightbox-' + index,
				openEffect: 'fadeIn',
				closeEffect: 'fadeOut',
				videosWidth: 1280,
			});
		});

		$('[target^="lightbox-gallery"]').each(function() {

			const gallery = this.getAttribute('target');
			this.classList.add(gallery);

			GLightbox({
				selector: gallery,
				openEffect: 'fadeIn',
				closeEffect: 'fadeOut',
				videosWidth: 1280,
			});
		});

		$('.btn-group-slider').each(function() {

			if(!this.swiper) {

				const swiper = new Swiper(this, {
					loop: false,
					slidesPerView: 'auto',
					slideToClickedSlide: true,
					preventInteractionOnTransition: true,
					resistance: false,
					speed: TransitionDurations.default,
					observer: true,
				});
			}
		});

		// ---------- Cookies ----------

		initGTM();

		if(!getCookiesAllowed()) {

			const cookies = document.querySelector('#cookies-allowed');

			if(cookies) {

				cookies.classList.remove(Classes.hidden);
				await wait(100);
				cookies.classList.add(Classes.show);

				$(cookies).on('click', '[data-dismiss="alert"]', function() {
					setCookiesAllowed(this.dataset.allowed);
				});
			}
		}

	});

	// ---------- Disclaimer ----------

	if(!isDisclaimerAccepted()) {

		const disclaimer = document.querySelector('#disclaimer');

		if(disclaimer) {

			disclaimer.classList.remove(Classes.hidden);
			$Elements.body.addClass(Classes.disclaimer);

			$(disclaimer).on('close.bs.alert', function() {
				setDisclaimerAccepted();
				$Elements.body.removeClass(Classes.disclaimer);
			});

			$(disclaimer).on('closed.bs.alert', () => $Elements.document.trigger(BrowserEvents.disclaimer.accepted));
		}
	}

}(jQuery));
